import { render, staticRenderFns } from "./testScoreDialog.vue?vue&type=template&id=d6f12f00&scoped=true"
import script from "./testScoreDialog.vue?vue&type=script&lang=js"
export * from "./testScoreDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_n3acbem2au4l2e3t4qvos3rwwq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f12f00",
  null
  
)

export default component.exports